import { useSelector, shallowEqual } from "react-redux";
import CreditCardMarketingBanner from "app/pages/Booking/Payment/CreditCardMarketingBanner/CreditCardMarketingBanner";

const mapStateToProps = state => {
	return {
		brand: state.brand.code,
		resolution: state.resolution,
		shop: state.shop,
	};
};

const CreditCardMarketingBannerContainer = props => {
	const stateProps = useSelector(mapStateToProps, shallowEqual);
	return <CreditCardMarketingBanner {...props} {...stateProps} />;
};

export default CreditCardMarketingBannerContainer;
